import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { ActingTonightOptionType } from '@/pages/Onboarding/options/ActingTonight/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import {
  PageStyles,
  OptionsContainerStyles,
  TitleStyles,
  SubtitleStyles,
} from './ActingTonight.styles';
import { Option, OptionList } from './components/Option';
import { ACTING_TONIGHT_OPTIONS } from './constants';

export const ScreenActingTonight: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ActingTonight',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();
  const actingTonight = form.watch('acting_tonight');

  const handleChange = (option: ActingTonightOptionType) => {
    form.setValue('acting_tonight', option.id);
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        acting_tonight: form.getValues('acting_tonight'),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <OnboardingNavigation />
      <TitleStyles>How are they acting tonight?</TitleStyles>
      <SubtitleStyles>
        The vibe is real. What's their energy toward you?
      </SubtitleStyles>
      <IonContent>
        <OptionsContainerStyles className="options-container">
          <OptionList>
            {ACTING_TONIGHT_OPTIONS.map((option: ActingTonightOptionType) => (
              <Option
                title={option.title}
                subtitle={option.subtitle}
                emoji={option.emoji}
                isSelected={actingTonight === option.id}
                onClick={() => handleChange(option)}
                key={option.id}
              />
            ))}
          </OptionList>
        </OptionsContainerStyles>
      </IonContent>

      <OnboardingFooter
        disabled={!actingTonight}
        onContinue={handleNextStep}
        buttonText="Continue"
      />
    </PageStyles>
  );
};
